
export const Papers = [
    {
        title: 'Comparison of computed tomography and dual-energy X-ray absorptiometry in the evaluation of body composition in patients with obesity.',
        author: 'Palmas, Fiorella, et al.',
        date: '2023',
        journal: 'Frontiers in Endocrinology',
        doi: 'https://doi.org/10.3389/fendo.2023.1161116',
        src: 'assets/papers/paper_1.png',
    },
    {
        title: 'Body composition assessment with ultrasound muscle measurement: optimization through the use of semi-automated tools in colorectal cancer.',
        author: 'Palmas, Fiorella, et al.',
        date: '2024',
        journal: 'Frontiers in Nutrition',
        doi: 'https://doi.org/10.3389/fnut.2024.1372816',
        src: 'assets/papers/paper_2.png',
    },
    {
        title: 'AI-Assisted Body Composition Assessment Using CT Imaging in Colorectal Cancer Patients: Predictive Capacity for Sarcopenia and Malnutrition Diagnosis.',
        author: 'Soria-Utrilla, Virginia, et al.',
        date: '2024',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu16121869',
        src: 'assets/papers/paper_3.png',
    },
    {
        title: 'IA-Body Composition CT at T12 in Idiopathic Pulmonary Fibrosis: Diagnosing Sarcopenia and Correlating with Other Morphofunctional Assessment Techniques.',
        author: 'Fernández-Jiménez, Rocío, et al.',
        date: '2024',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu16172885',
        src: 'assets/papers/paper_4.png',
    },
    {
        title: 'Evaluation of Muscle Mass and Malnutrition in Patients with Colorectal Cancer Using the Global Leadership Initiative on Malnutrition Criteria and Comparing Bioelectrical Impedance Analysis and Computed Tomography Measurements.',
        author: 'de Luis Roman, Daniel, et al.',
        date: '2024',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu16173035',
        src: 'assets/papers/paper_5.png',
    },
    {
        title: 'Multiparametric Approach to the Colorectal Cancer Phenotypes Integrating Morphofunctional Assessment and Computer Tomography.',
        author: 'Guirado-Peláez, Patricia, et al.',
        date: '2024',
        journal: 'Cancers',
        doi: 'https://doi.org/10.3390/cancers16203493',
        src: 'assets/papers/paper_6.png',
    },
    {
        title: 'The Nutritional Phenotyping of Idiopathic Pulmonary Fibrosis Through Morphofunctional Assessment: A Bicentric Cross-Sectional Case–Control Study.',
        author: 'Sanmartín-Sánchez, Alicia, et al.',
        date: '2025',
        journal: 'Life',
        doi: 'https://doi.org/10.3390/life15040516',
        src: 'assets/papers/paper_7.png',
    },
    {
        title: 'Artificial intelligence in dysphagia assessment: evaluating lingual muscle composition in head and neck cancer.',
        author: 'Ferrera Alayón, Laura, et al.',
        date: '2025',
        journal: 'Clinical and Translational Oncology',
        doi: 'https://doi.org/10.1007/s12094-025-03900-6',
        src: 'assets/papers/paper_8.png',
    },
    {
        title: 'Machine-learning model based on computed tomography body composition analysis for the estimation of resting energy expenditure: A pilot study.',
        author: 'Palmas, Fiorella, et al.',
        date: '2025',
        journal: 'Clinical Nutrition ESPEN',
        doi: 'https://doi.org/10.1016/j.clnesp.2025.05.031',
        src: 'assets/papers/paper_9.png',
    },
    {
        title: 'Prognostic Value of Computed Tomography-Derived Muscle Density for Postoperative Complications in Enhanced Recovery After Surgery (ERAS) and Non-ERAS Patients.',
        author: 'Palmas, Fiorella, et al.',
        date: '2025',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu17142264',
        src: 'assets/papers/paper_10.png',
    },
    {
        title: 'Cachexia Phenotyping Through Morphofunctional Assessment and Mitocondrial Biomarkers (GDF-15 and PGC-1α) in Idiopathic Pulmonary Fibrosis.',
        author: 'Sanmartín-Sánchez, Alicia, et al.',
        date: '2025',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu17172739',
        src: 'assets/papers/paper_11.png',
    },
    {
        title: 'Integrating Imaging and Nutrition: Chest CT Muscle Analysis in Adults with Cystic Fibrosis.',
        author: 'Soria-Utrilla, Virginia, et al.',
        date: '2025',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu17182940',
        src: 'assets/papers/paper_12.png',
    },
    {
        title: 'Albumin-myosteatosis gauge as a prognostic factor and its relationships with bioimpedancemetry in patients with colorectal cancer.',
        author: 'de Luis, Daniel, et al.',
        date: '2025',
        journal: 'Clinical Nutrition ESPEN',
        doi: 'https://doi.org/10.1016/j.clnesp.2025.09.032',
        src: 'assets/papers/paper_13.png',
    },
    {
        title: 'Artificial intelligence–assisted rectus femoris ultrasound vs. L3 computed tomography for sarcopenia assessment in oncology patients: Establishing diagnostic cut-offs for muscle mass and quality.',
        author: 'López-Gómez, Juan José, et al.',
        date: '2025',
        journal: 'Frontiers in Nutrition',
        doi: 'https://doi.org/10.3389/fnut.2025.1678989',
        src: 'assets/papers/paper_14.png',
    },
    {
        title: 'AI-assistance body composition CT at T12 and T4 in lung cancer: Diagnosing sarcopenia, and its correlation with morphofunctional assessment techniques.',
        author: 'Montero-Benitez, Maria Zhao, et al.',
        date: '2025',
        journal: 'Cancers',
        doi: 'https://doi.org/10.3390/cancers17193255',
        src: 'assets/papers/paper_15.png',
    },
    {
        title: 'Sex-specific CT-derived muscle and fat phenotypes in colon cancer: implications for nutritional and metabolic assessment.',
        author: 'Mucarzel, Fernanda, et al.',
        date: '2025',
        journal: 'Frontiers in Nutrition',
        doi: 'https://doi.org/10.3389/fnut.2025.1728741',
        src: 'assets/papers/paper_16.png',
    },
    {
        title: 'Development and Internal Evaluation of AI-Assisted Cervical Muscle-Based Scores (FUNC-RISK) in Head and Neck Cancer: A Pilot Study.',
        author: 'Ferrera Alayón, Laura, et al.',
        date: '2025',
        journal: 'Cancers',
        doi: 'https://doi.org/10.3390/cancers17243968',
        src: 'assets/papers/paper_17.png',
    },
    {
        title: 'FocusedON-BC: A Robust Deep Learning Framework for Automated Body Composition Assessment.',
        author: 'Rubio-García, Jano Manuel, et al.',
        date: '2026',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu18091477',
        src: 'assets/papers/paper_18.png',
    },
    {
        title: 'CT Assessment of Body Composition and Lung Evolution in Cystic Fibrosis After Elexacaftor-Tezacaftor-Ivacaftor: A Cohort Study.',
        author: 'Soria-Utrilla, Virginia, et al.',
        date: '2026',
        journal: 'Respiratory Medicine',
        doi: 'https://doi.org/10.1016/j.rmed.2026.108942',
        src: 'assets/papers/paper_19.png',
    },
    {
        title: 'Major Adverse Nutritional Events (MANE): a composite outcome linking body composition and postoperative risk in colorectal cancer surgery.',
        author: 'Palmas, Fiorella, et al.',
        date: '2026',
        journal: 'Clinical Nutrition',
        doi: 'https://doi.org/10.1016/j.clnu.2026.106821',
        src: 'assets/papers/paper_20.png',
    },
    {
        title: 'Prognostic Impact of Overhydration in Hospitalized Patients Receiving Parenteral Nutrition.',
        author: 'Zabalegui-Eguinoa, Alba, et al.',
        date: '2026',
        journal: 'Nutrients',
        doi: 'https://doi.org/10.3390/nu18213528',
        src: 'assets/papers/paper_21.png',
    },
]
